import * as Yup from "yup";
import { validateEmail } from "../common";

export const forgotPasswordSchema = Yup.object().shape({
  mail: validateEmail,
});
